export default "__VITE_ASSET__D0RElweT__"